import { render, staticRenderFns } from "./rotate-screen.vue?vue&type=template&id=74bb3f6d&scoped=true&"
import script from "./rotate-screen.vue?vue&type=script&lang=js&"
export * from "./rotate-screen.vue?vue&type=script&lang=js&"
import style0 from "./rotate-screen.vue?vue&type=style&index=0&id=74bb3f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb3f6d",
  null
  
)

export default component.exports